<template>
  <div>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        v-if="item !== null && item !== undefined"
      >
        <v-container>
          <div class="row">
            <div class="col-12 col-md-4 col-lg-3">
              <trans-select2
                v-model="item"
                propertyName="BillingTerm"
                :items="terms"
                :label="$t('headers.contributionterms.name')"
                field="Name"
                itemValue="Id"
                :rules="[$rules.required]"
                class="required"
              ></trans-select2>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.Amount"
                :label="$t('globals.amount')"
                class="required"
                :rules="[$rules.decimal]"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.PPTax"
                :label="$t('headers.adjustments.PPTax')"
                :rules="[$rules.decimal]"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.PSTax"
                :label="$t('headers.adjustments.PSTax')"
                :rules="[$rules.decimal]"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.RSTax"
                :label="$t('headers.adjustments.RSTax')"
                :rules="[$rules.decimal]"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.QSTax"
                :label="$t('headers.adminfees.QSTax')"
                :rules="[$rules.decimal]"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.HSTax"
                :label="$t('headers.adjustments.HSTax')"
                :rules="[$rules.decimal]"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.GSTax"
                :label="$t('headers.adjustments.GSTax')"
                :rules="[$rules.decimal]"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                :readonly="true"
                v-model="totalFee"
                :label="$t('headers.adjustments.total')"
                class="required"
                :disabled="true"
                :rules="[$rules.requiredNum, $rules.decimal]"
              />
            </div>
          </div>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        @click="
          item = null;
          $emit('close');
        "
        :loading="saving"
      >
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn color="primary" :loading="saving" @click="save" :disabled="!valid">
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import TransSelect2 from "../../components/TransSelect2";
import { mapActions, mapGetters } from "vuex";
import CurrencyTextfield from "../CurrencyTextfield.vue";
import { translate2 } from "@/trans2";

export default {
  components: {
    TransSelect2,
    CurrencyTextfield,
  },
  props: {
    adminFee: Object,
    saving: Boolean,
  },
  data: () => ({
    valid: false,
    loading: false,
    error: null,
    item: null,
    terms: [],
    totalFee: 0,
  }),
  watch: {
    adminFee: {
      handler(v) {
        if (v) {
          this.item = v; //JSON.parse(JSON.stringify(v))
        }
      },
    },
    item: {
      deep: true,
      handler() {
        if (this.item) {
          this.totalFee =
            Math.round(
              (parseFloat(this.item.Amount ? this.item.Amount : "0") +
                parseFloat(this.item.PPTax ? this.item.PPTax : "0") +
                parseFloat(this.item.PSTax ? this.item.PSTax : "0") +
                parseFloat(this.item.RSTax ? this.item.RSTax : "0") +
                parseFloat(this.item.QSTax ? this.item.QSTax : "0") +
                parseFloat(this.item.GSTax ? this.item.GSTax : "0") +
                parseFloat(this.item.HSTax ? this.item.HSTax : "0")) *
                100
            ) / 100;
        }
      },
    },
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  async mounted() {
    this.item = this.adminFee;
    this.terms = (
      await this.getBillingTerms({
        plan: this.selectedPlan.Id,
      })
    ).data.value;
  },
  methods: {
    ...mapActions("plansMembers", ["getBillingTerms"]),
    save() {
      if (this.item.Id !== undefined && this.item.Id !== null) {
        this.$emit("update", this.item);
      } else {
        this.$emit("add", this.item);
      }
      this.item = null;
    },
    trans(item, field) {
      return translate2(item, field);
    },
    transFilterFunc(item, search) {
      return (
        this.trans(item, "Name").toLowerCase().indexOf(search.toLowerCase()) >
        -1
      );
    },
  },
};
</script>
